// extracted by mini-css-extract-plugin
module.exports = {"container":"single-module--container--1YBiM","footer":"single-module--footer--3HWJE"};